import OldInspectionDetailsLink from './OldInspectionDetailsLink';

export default OldInspectionDetailsLink;
